/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import './dep-a48de419.mjs';
import { b as _Symbol$1 } from './dep-3ca5fb38.mjs';
import { _ as _arrayMap } from './dep-192e10f1.mjs';
import { i as isArray_1 } from './dep-3d4aad09.mjs';
import { i as isSymbol_1 } from './dep-977c5cdd.mjs';

var _Symbol = _Symbol$1,
    arrayMap = _arrayMap,
    isArray = isArray_1,
    isSymbol = isSymbol_1;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$1) + '';
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString;

export { _baseToString as _, toString_1 as t };
//# sourceMappingURL=dep-a82b01df.mjs.map
